export default __webpack_public_path__ + "static/media/totalWaffel.d9217554.png";